import type { BorrowMarketAssetData } from '@/utils/internalAppSdk'

type BorrowMarketInterestRateModel = NonNullable<BorrowMarketAssetData['interestRateModel']>

export const calculateBorrowRateAtUtilization = (
  interestRateModel: BorrowMarketInterestRateModel,
  utilizationRate: number
) => {
  const utilization = Math.min(Math.max(utilizationRate, 0), 1)
  const optimalUtilization = Math.min(Math.max(interestRateModel.optimalUtilization, 0), 1)

  if (optimalUtilization === 0) {
    return interestRateModel.baseRate + interestRateModel.slope1 + interestRateModel.slope2 * utilization
  }

  if (utilization <= optimalUtilization) {
    return interestRateModel.baseRate + interestRateModel.slope1 * (utilization / optimalUtilization)
  }

  if (optimalUtilization === 1) {
    return interestRateModel.baseRate + interestRateModel.slope1
  }

  return (
    interestRateModel.baseRate +
    interestRateModel.slope1 +
    interestRateModel.slope2 * ((utilization - optimalUtilization) / (1 - optimalUtilization))
  )
}
